import { ValidationStatus } from '@onwardtravelsolutions/package-react/Enums';
import { Notice } from '@onwardtravelsolutions/package-react/Types';
import React, { useEffect, useState } from 'react';
import { getValidation } from '../../Utilities/validation';
import CheckboxField from './CheckboxField';
import ValidationList from './ValidationList';

type CheckboxesFieldProps = {
    id: string;
    items: {
        value: string | number;
        label: string | number | React.ReactElement;
    }[];
    setValue?: (value: any) => void;
    status?: ValidationStatus;
    value?: string[];
    isDirty?: boolean;
    tabIndex?: number | null;
    notices?: Notice[];
    name: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export default function CheckboxesField({
    id,
    name,
    value = [],
    items,
    isDirty,
    status,
    setValue,
    tabIndex,
    notices = [],
}: CheckboxesFieldProps) {
    // Manage Grouped Field(s) State
    const [values, setValues] = useState<string[] | number[]>(value);

    useEffect(() => {
        if ((isDirty || !areArraysEqual(values, value)) && setValue) {
            setValue(values);
        }
    }, [values, isDirty, value]);

    const validation = getValidation(status);

    return (
        <div
            className={`relative overflow-hidden bg-gray-50 dark:bg-neutral-700 border rounded ${validation.borderClasses}`}
        >
            {items.map(({ value, label }, index) => {
                return (
                    <CheckboxField
                        key={`${id}-${index}`}
                        {...{
                            id: `${id}-${index}`,
                            value,
                            status,
                            name,
                            tabIndex,
                            onChange: (event) => {
                                const isChecked = (
                                    event.target as HTMLInputElement
                                ).checked;
                                setValues((previous: any[]) => {
                                    if (isChecked) {
                                        return [...previous, value];
                                    } else {
                                        const values = [...previous];
                                        values.splice(
                                            previous.indexOf(value),
                                            1,
                                        );
                                        return values;
                                    }
                                });
                            },
                        }}
                    >
                        {label}
                    </CheckboxField>
                );
            })}
            {notices.length ? (
                <ValidationList
                    {...{
                        fieldName: name,
                        notices: notices,
                    }}
                />
            ) : null}
        </div>
    );
}

function areArraysEqual(a: (string | number)[], b: (string | number)[]) {
    return a.length === b.length && a.every((value, index) => value === b[index]);
}